<script lang="ts">
	export let showMenu: Boolean = false;
</script>

<div class="burger {showMenu ? 'active' : ''}" />

<style>
	.burger {
		display: flex;
		outline: none;
		height: 20px;
		width: 15px;
		border: 0px;
		padding: 0px;
		align-items: center;
		background: transparent;
		transition: all 250ms ease-out;
		cursor: pointer;
	}

	.burger:before,
	.burger:after {
		content: '';
		width: 24px;
		height: 2px;
		position: absolute;
		background: #9ea4a1;
		transition: all 250ms ease-out;
		will-change: transform;
	}

	.burger:before {
		transform: translateY(-3px);
	}

	.burger:after {
		transform: translateY(3px);
	}

	.active.burger:before {
		transform: translateY(0) rotate(45deg);
	}

	.active.burger:after {
		transform: translateY(0) rotate(-45deg);
	}
</style>
